/**
 * Хелперы для клавиатуры в текстовых полях (chat inputs, textarea'ы).
 *
 * Главная задача — одинаковое поведение на десктопе и мобилке:
 *   - Desktop (hover: hover): Enter отправляет, Shift+Enter = перенос строки
 *   - Mobile/tablet (touch-only): Enter ВСЕГДА = перенос строки. Shift+Enter
 *     на мобильной клавиатуре нажать невозможно, и if мы будем отправлять по
 *     Enter'у, юзер вообще не сможет сделать многострочное сообщение. Отправка
 *     только через кнопку Send.
 *
 * Также учитываем IME-composition (китайский / японский ввод) — во время
 * выбора иероглифа Enter подтверждает вариант ввода, НЕ должен отправлять.
 */

/** Возвращает true если Enter должен отправить сообщение. Иначе — текстовое
 *  поле должно обработать Enter стандартно (перенос строки). */
export function shouldSendOnEnter(e: React.KeyboardEvent): boolean {
	if (e.key !== 'Enter') return false
	if (e.shiftKey) return false
	// CJK IME composition — подтверждение варианта ввода, не отправка
	if (e.nativeEvent.isComposing) return false
	// Мобилка / тач-устройство — Enter всегда перенос строки.
	// Тройная проверка чтобы ловить и реальную мобилку, и DevTools-emulation:
	//   1. hover: none — надёжный сигнал touch (iPhone, Android real devices)
	//   2. pointer: coarse — тач-палец вместо мыши
	//   3. viewport < 768 — fallback для эмуляции в DevTools и ручного
	//      ресайза десктопа под мобильный вид
	if (typeof window !== 'undefined') {
		if (window.matchMedia?.('(hover: none)').matches) return false
		if (window.matchMedia?.('(pointer: coarse)').matches) return false
		if (window.innerWidth < 768) return false
	}
	return true
}
